module.exports = __webpack_public_path__ + "static/media/google-play-editor-choice@2x.28bce806.png";